module["exports"] = [
  "####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/postcode.js
// module id = 992
// module chunks = 1